import styled, {css} from 'styled-components';

export const Fields = styled.div<{$centered?: boolean}>`
  display: grid;
  align-self: stretch;

  ${({$centered}) =>
    $centered &&
    css`
      justify-items: center;
    `}
`;

export const GroupTitle = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  font-weight: 600;
  line-height: 24px;
  text-align: start;
  padding-block: 8px;

  border-bottom: 1px solid #dee2db;
  margin-bottom: 24px;

  grid-column: 1 / -1;
  align-self: stretch;
  justify-self: stretch;
`;
